import { Divider, Grid, Typography } from '@mui/material';
import React, { useEffect, useRef } from 'react';
import ApiKeyCongifuration from '../../../Ancillary/AIConfig/views/ApiKeyCongifuration';
import AIModelConfigGrid from '../../../Ancillary/AIConfig/views/AIModelConfigGrid';
import { useTheme } from "@mui/material/styles";
import { useSelector } from 'react-redux';
import AIDowntimePopup from '../../../ATS/helper/Ancillary/AIDowntimePopup';

const AIConfigLandingPage = () => {
    const theme = useTheme();
    const aiDowntimeRef = useRef();

    const { atsModuleData } = useSelector((state) => state?.RoleAndAccessReducer?.ATSModuleReducer);

    const AIDowntime = atsModuleData?.find((item) => item.module_name === "AI Downtime");

    useEffect(() => {
        if (AIDowntime && aiDowntimeRef.current) {
            aiDowntimeRef.current.openPopup();
        }
    }, [AIDowntime]);

    const values = [
        { name: "", comp: <ApiKeyCongifuration /> },
        { name: "AI Model", comp: <AIModelConfigGrid /> },
    ];

    return (
        <Grid container spacing={2} style={{ padding: "10px 0px", position: "relative" }}>
            {values?.map((value, id) => (
              <React.Fragment key={id}>
                <Grid
                    item
                    xs={12}
                    md={12}
                    >
                    {value?.name && (
                        <Typography
                        variant="h6"
                        gutterBottom
                        sx={{
                        paddingLeft: "15px",
                        color: theme.palette.primary.contrastText,
                        }}
                    >
                        {value?.name}
                    </Typography>)}
                    {value?.comp}
                </Grid>
                {([0].includes(id)) && (
                    <Grid item xs={12}>
                        <Divider sx={{ my: 1 }} />
                    </Grid>
                )}
              </React.Fragment>

            ))}
            <AIDowntimePopup ref={aiDowntimeRef} closeReq={false} style={{ inset: 0 }} />
        </Grid>
    );
};

export default AIConfigLandingPage;
